import { render, staticRenderFns } from "./TouchpointInfo.vue?vue&type=template&id=08d48c94&"
import script from "./TouchpointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d48c94')) {
      api.createRecord('08d48c94', component.options)
    } else {
      api.reload('08d48c94', component.options)
    }
    module.hot.accept("./TouchpointInfo.vue?vue&type=template&id=08d48c94&", function () {
      api.rerender('08d48c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointInfo.vue"
export default component.exports